import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-eligibility-intake',
  templateUrl: './eligibility-intake.component.html',
  styleUrls: ['./eligibility-intake.component.scss']
})
export class EligibilityIntakeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
